/**
 * Free Shipping Banner Section
 * - Reveals the highlighted "free shipping" box with a small fade/slide-in
 *   animation once it scrolls into view.
 * - Re-initializes correctly when the section is added/edited live in the
 *   Shopify theme editor (section re-renders on every setting change).
 */
(function () {
  'use strict';

  function initFreeShippingBanner(root) {
    var banners = root.querySelectorAll('[data-fsb-banner]');
    if (!banners.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just show it immediately on unsupported browsers.
      banners.forEach(function (el) {
        el.classList.add('fsb-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fsb-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    banners.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Initial page load
  document.addEventListener('DOMContentLoaded', function () {
    initFreeShippingBanner(document);
  });

  // Theme editor support: re-run when this section is loaded/reordered
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-fsb-banner]')) {
      initFreeShippingBanner(event.target);
    }
  });

  // In case the script executes after DOMContentLoaded already fired
  // (e.g. loaded dynamically via theme editor), run once immediately too.
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initFreeShippingBanner(document);
  }
})();
